import { useEffect } from 'react';
import Swal from 'sweetalert2';
import { formatearMoneda } from "../../../../funcionesDatos/Moneda";

// Con precios más bajos, la comisión de Zervicy (20%) no alcanza a cubrir los costos fijos
// de la pasarela de pago (checkout + payout de Wompi), y la reserva le da pérdida a la plataforma.
const PRECIO_MINIMO_PAQUETE_COP = 50000;

function Paso4({
  cantidadPaquetes,
  setCantidadPaquetes,
  paqueteActivo,
  setPaqueteActivo,
  paquetes,
  actualizarPaquete,
  actualizarTodosPaquetes,
  agendaAbierta,
  setAgendaAbierta,
  comisionHPM,
  desgloseCobro,
  impuestoPais,
  divisaServicio,
  tipoServicio,
  urgente,
  BotonesaPasos,
  setPasoActual,
  guardarProgreso,
}) {

  // Si el servicio es urgente: forzamos exacta y bloqueamos días
  useEffect(() => {
    if (!!urgente) {
      if (agendaBase?.modoAgenda === 'flexible') {
        actualizarTodosPaquetes('modoAgenda', 'exacta');
      }
      if ((agendaBase?.unidadEntrega || 'Horas') === 'Dias') {
        actualizarTodosPaquetes('unidadEntrega', 'Horas');
      }
    }
  }, [urgente]);

  // Usamos Básico como fuente de verdad para los campos compartidos
  const agendaBase = paquetes.Basico;

  return (
    <div className="card border-0 shadow-sm">
      <div className="card-body position-relative">
        <div className="d-flex align-items-center gap-2 position-absolute top-0 end-0 m-3">
          <span className="badge rounded-pill border" style={{ backgroundColor: "var(--color-bg-accent-subtle)", color: "var(--color-text-primary)", borderColor: "var(--azul-cielo)", fontWeight: 600 }}>
            {divisaServicio === "USD" ? "🇺🇸 USD" : "🇨🇴 COP"}
          </span>
          <span className="badge text-bg-primary">4 / 5</span>
        </div>
        <h3 className="mt-2">Paquetes</h3>
        <p>Ofrece 1, 2 o 3 opciones (las que desees). Esto aumenta tus ventas y tu ticket promedio.</p>

        {/* ── SECCIÓN 1: CANTIDAD + TIP ───────────────────────────── */}
        <div className="row g-3 align-items-end">
          <div className="col-12 col-md-6">
            <label className="form-label fw-bold">Cantidad de paquetes</label>
            <select
              className="form-select"
              value={cantidadPaquetes}
              onChange={(e) => {
                const n = parseInt(e.target.value, 10);
                setCantidadPaquetes(n);
                if (n === 1) setPaqueteActivo('Basico');
                if (n === 2 && paqueteActivo === 'Avanzado') setPaqueteActivo('Premium');
              }}
            >
              <option value={1}>1 (Básico)</option>
              <option value={2}>2 (Básico + Premium)</option>
              <option value={3}>3 (Básico + Premium + Avanzado)</option>
            </select>
          </div>
          <div className="col-12 col-md-6">
            <div className="alert alert-info mb-0" role="alert">
              <strong>Tip:</strong> empieza con 1 paquete hoy. Luego añades 2 y 3 cuando ya tengas pedidos.
            </div>
          </div>
        </div>

        {/* ── SECCIÓN 2: AGENDA COMPARTIDA (aplica a todos los paquetes) ── */}
        <div className="border rounded-3 p-3 mt-4 bg-light">
          <p className="fw-bold mb-3 text-muted" style={{ fontSize: 13 }}>
            CONFIGURACIÓN DE AGENDA — aplica a todos los paquetes
          </p>

          <div className="row g-3">

            {/* DÍAS DE LA SEMANA */}
            <div className="col-12 col-lg-6">
              <label className="form-label fw-bold">¿Qué días prestarás este servicio?</label>
              <div className="d-flex flex-wrap gap-2">
                <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => actualizarTodosPaquetes('diasSemana', [1,2,3,4,5])}>Lunes a viernes</button>
                <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => actualizarTodosPaquetes('diasSemana', [6,7])}>Fin de semana</button>
                <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => actualizarTodosPaquetes('diasSemana', [1,2,3,4,5,6,7])}>Todos los días</button>
                <button type="button" className="btn btn-sm btn-secondary"       onClick={() => actualizarTodosPaquetes('diasSemana', [])}>Limpiar</button>
              </div>
              <div className="mt-2 d-flex flex-wrap gap-2">
                {([
                  { n: 1, t: 'Lun' }, { n: 2, t: 'Mar' }, { n: 3, t: 'Mié' },
                  { n: 4, t: 'Jue' }, { n: 5, t: 'Vie' }, { n: 6, t: 'Sáb' }, { n: 7, t: 'Dom' },
                ]).map((d) => {
                  const seleccionados = Array.isArray(agendaBase.diasSemana) ? agendaBase.diasSemana : [];
                  const activo = seleccionados.includes(d.n);
                  return (
                    <button
                      key={d.n}
                      type="button"
                      className={`btn btn-sm ${activo ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => {
                        const next = activo
                          ? seleccionados.filter(x => x !== d.n)
                          : [...seleccionados, d.n].sort((a, b) => a - b);
                        actualizarTodosPaquetes('diasSemana', next);
                      }}
                    >
                      {d.t}
                    </button>
                  );
                })}
              </div>
              <small className="text-muted">Estos son los días en los que el cliente podrá agendar cualquier paquete.</small>
            </div>

            {/* DURACIÓN DEL SERVICIO (Días u Horas) */}
            <div className="col-12 col-lg-6">
              <label className="form-label fw-bold d-flex align-items-center gap-2">
                <span>Duración del servicio</span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  style={{ padding: '0.15rem 0.4rem', lineHeight: 1 }}
                  onClick={() => {
                    const esDigital = String(tipoServicio || '').toLowerCase() === 'digital';
                    return Swal.fire({
                      icon: 'info',
                      title: '¿Días u Horas?',
                      html: `
                        <div style="text-align:left;font-size:15px;line-height:1.55">
                          ${esDigital
                            ? `<div>Elige <b>Días</b> cuando tu servicio es por <b>entrega</b> (diseño, logo, web).
                               Elige <b>Horas</b> cuando es una <b>sesión</b> agendada (asesoría, consultoría).</div>`
                            : `<div>Elige <b>Días</b> cuando el trabajo se mide por <b>duración en días</b> (reparaciones, pintura).
                               Elige <b>Horas</b> cuando el servicio es por <b>cita</b> (uñas, clases, chef).</div>`
                          }
                          <div class="alert alert-info" style="margin-top:12px;padding:12px;border-radius:10px">
                            <b>Importante:</b> esta configuración aplica a todos los paquetes del servicio.
                          </div>
                        </div>`,
                      confirmButtonText: 'Entendido',
                      customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
                    });
                  }}
                  title="Ayuda"
                >
                  Ayuda
                </button>
              </label>
              <select
                className="form-select"
                value={agendaBase.unidadEntrega || 'Horas'}
                onChange={(e) => {
                  const nueva = e.target.value;
                  actualizarTodosPaquetes('unidadEntrega', nueva);
                }}
              >
                <option value="Horas">Horas</option>
                <option value="Dias" disabled={!!urgente}>Días{!!urgente ? ' — no compatible con urgente' : ''}</option>
              </select>
              {!!urgente && (
                <small className="text-warning fw-semibold mt-1 d-block">
                  El modo urgente solo aplica a servicios por horas (citas).
                </small>
              )}

              {/* SI ES DÍAS: nota de que los días de entrega se configuran por paquete */}
              {(agendaBase.unidadEntrega || 'Dias') === 'Dias' && (
                <div className="mt-3">
                  <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                    Los días de entrega se configuran en cada paquete a continuación.
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* AGENDA POR HORAS (solo si unidad es Horas) */}
          {(agendaBase.unidadEntrega || 'Dias') === 'Horas' && (
            <div className="mt-3">
              <div className="accordion agenda-accordion" id="accAgendaGlobal">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#accAgendaGlobalC"
                      aria-expanded="false"
                      aria-controls="accAgendaGlobalC"
                      onClick={() => setAgendaAbierta(prev => ({ ...prev, global: !prev?.global }))}
                    >
                      <span className="d-flex align-items-center gap-2">
                        <span>Configurar agenda por horas</span>
                        <i className={`bi ${agendaAbierta?.global ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                      </span>
                    </button>
                  </h2>

                  <div id="accAgendaGlobalC" className="accordion-collapse collapse" data-bs-parent="#accAgendaGlobal">
                    <div className="accordion-body agenda-accordion-body">
                      <div className="alert alert-info mb-3" role="alert">
                        <strong>Importante:</strong> esta agenda aplica a todos los paquetes. Define tus horarios disponibles.
                      </div>

                      {/* TIPO AGENDA */}
                      <div className="mb-3">
                        <label className="form-label fw-bold d-flex align-items-center gap-2">
                          <span>Tipo de agenda</span>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            style={{ padding: '0.15rem 0.4rem', lineHeight: 1 }}
                            onClick={() => Swal.fire({
                              icon: 'info',
                              title: 'Tipo de agenda',
                              html: `<div style="text-align:left;font-size:15px;line-height:1.55">
                                <div><b>Horarios exactos:</b> configuras las horas disponibles.</div>
                                <div style="margin-top:8px"><b>Horarios flexibles:</b> el cliente elige una hora y tienes 40 minutos para confirmar; si no respondes, se confirma automáticamente.</div>
                              </div>`,
                              confirmButtonText: 'Entendido',
                              customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
                            })}
                            title="Ayuda"
                          >
                            Ayuda
                          </button>
                        </label>
                        <div className="d-flex flex-wrap gap-2">
                          <button
                            type="button"
                            className={`btn btn-sm ${((agendaBase.modoAgenda || 'exacta') === 'exacta') ? 'btn-primary' : 'btn-outline-primary'}`}
                            onClick={() => actualizarTodosPaquetes('modoAgenda', 'exacta')}
                          >
                            Horarios exactos
                          </button>
                          {!!urgente ? null : (
                            <button
                              type="button"
                              className={`btn btn-sm ${((agendaBase.modoAgenda || 'exacta') === 'flexible') ? 'btn-primary' : 'btn-outline-primary'}`}
                              onClick={() => actualizarTodosPaquetes('modoAgenda', 'flexible')}
                            >
                              Horarios flexibles
                            </button>
                          )}
                        </div>
                      </div>


                      {/* FRANJAS (flexible) o HORARIOS EXACTOS (exacta) */}
                      {(agendaBase.modoAgenda || 'exacta') === 'flexible' ? (
                        <div className="row g-3 mt-3">
                          <div className="col-12">
                            <label className="form-label fw-bold">¿En qué franjas prefieres prestar el servicio?</label>
                            <div className="d-flex flex-wrap gap-2">
                              {[
                                { k: 'manana', t: 'Mañana (7:00–12:00)' },
                                { k: 'tarde',  t: 'Tarde (12:00–18:00)' },
                                { k: 'noche',  t: 'Noche (18:00–22:00)' },
                              ].map((f) => {
                                const sel = Array.isArray(agendaBase.franjasDia) ? agendaBase.franjasDia : [];
                                const activo = sel.includes(f.k);
                                return (
                                  <button
                                    key={f.k}
                                    type="button"
                                    className={`btn btn-sm ${activo ? 'btn-primary' : 'btn-outline-primary'}`}
                                    onClick={() => {
                                      const next = activo ? sel.filter(x => x !== f.k) : [...sel, f.k];
                                      actualizarTodosPaquetes('franjasDia', next);
                                    }}
                                  >
                                    {f.t}
                                  </button>
                                );
                              })}
                              <button type="button" className="btn btn-sm btn-secondary" onClick={() => actualizarTodosPaquetes('franjasDia', [])}>Limpiar</button>
                            </div>
                            <small className="text-muted">El cliente propondrá una hora y tú confirmarás el horario.</small>
                          </div>
                        </div>
                      ) : (
                        <div className="row g-3 mt-3">
                          <div className="col-12">
                            <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                              La cantidad de servicios y los horarios exactos se configuran en cada paquete a continuación.
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>


        {/* ── SECCIÓN 3: TABS DE PAQUETES ─────────────────────────── */}
        <ul className="nav nav-tabs mt-4" role="tablist">
          <li className="nav-item" role="presentation">
            <button type="button" className={`nav-link ${paqueteActivo === 'Basico' ? 'active' : ''}`} onClick={() => setPaqueteActivo('Basico')}>
              Básico
            </button>
          </li>
          {cantidadPaquetes >= 2 && (
            <li className="nav-item" role="presentation">
              <button type="button" className={`nav-link ${paqueteActivo === 'Premium' ? 'active' : ''}`} onClick={() => setPaqueteActivo('Premium')}>
                Premium
              </button>
            </li>
          )}
          {cantidadPaquetes >= 3 && (
            <li className="nav-item" role="presentation">
              <button type="button" className={`nav-link ${paqueteActivo === 'Avanzado' ? 'active' : ''}`} onClick={() => setPaqueteActivo('Avanzado')}>
                Avanzado
              </button>
            </li>
          )}
        </ul>

        {/* FORMULARIO INTERNO DEL PAQUETE */}
        <div className="border border-top-0 rounded-bottom p-3 bg-white">
          <div className="row g-3">

            {/* PRECIO */}
            <div className="col-12 col-md-6">
              <label className="form-label fw-bold d-flex align-items-center gap-2">
                <span>Precio</span>
                <span className="badge text-bg-light border" title="Moneda del servicio">
                  {divisaServicio} {divisaServicio === 'COP' ? '🇨🇴' : ''}
                </span>
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  style={{ padding: '0.15rem 0.4rem', lineHeight: 1 }}
                  onClick={() => {
                    const precioNum = Number(String(paquetes?.[paqueteActivo]?.precio || "").replace(/[^0-9]/g, ""));
                    if (!Number.isFinite(precioNum) || precioNum <= 0) {
                      return Swal.fire({ icon: "info", title: "Desglose", text: "Ingresa un precio para ver el desglose.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
                    }
                    const tasaTxt             = impuestoPais > 0 ? `${Math.round(impuestoPais * 100)}%` : "0%";
                    const ivaServicio         = formatearMoneda(desgloseCobro?.ivaServicio, divisaServicio);
                    const precioBaseProveedor = formatearMoneda(desgloseCobro?.precioBaseProveedor, divisaServicio);
                    const totalServicio       = formatearMoneda(desgloseCobro?.totalServicio, divisaServicio);
                    const montoUrgencia       = formatearMoneda(desgloseCobro?.incrementoUrgencia, divisaServicio);
                    const pctUrgencia         = desgloseCobro?.incrementoUrgenciaPct * 100;
                    const montoPasarela       = desgloseCobro?.pasarela?.total;
                    const montoComisionHpm    = desgloseCobro?.comisionHpm;
                    const costoServicio       = formatearMoneda(montoComisionHpm + montoPasarela, divisaServicio);
                    const totalCliente        = formatearMoneda(desgloseCobro?.totalCliente, divisaServicio);
                    return Swal.fire({
                      title: "Desglose",
                      html: `
                        <div style="text-align:left;font-size:15px;line-height:1.4">
                          <table style="width:100%;border-collapse:collapse">
                            <tbody>
                              <tr><td style="padding:6px 0;font-weight:700">Precio base proveedor</td><td style="padding:6px 0;text-align:right">${precioBaseProveedor}</td></tr>
                              <tr><td style="padding:6px 0;font-weight:700">Incremento urgencia${desgloseCobro?.esUrgente ? ` (${pctUrgencia}%)` : ''}</td><td style="padding:6px 0;text-align:right">${montoUrgencia}</td></tr>
                              <tr><td style="padding:12px 0 6px 0;font-weight:800;font-size:16px">Total servicio</td><td style="padding:12px 0 6px 0;text-align:right;font-weight:800;font-size:16px">${totalServicio}</td></tr>
                              <tr><td colspan="2" style="padding:0 0 10px 0;font-size:12px;color:var(--gris-400)">De los cuales, <b>IVA incluido (${tasaTxt})</b>: ${ivaServicio}.</td></tr>
                              <tr><td style="padding:6px 0;font-weight:700">Costo de servicio</td><td style="padding:6px 0;text-align:right">${costoServicio}</td></tr>
                              <tr><td colspan="2" style="padding:0 0 10px 0;font-size:12px;color:var(--gris-400)">Incluye costos operativos de la plataforma.</td></tr>
                            </tbody>
                          </table>
                          <hr style="margin:12px 0"/>
                          <table style="width:100%;border-collapse:collapse">
                            <tbody>
                              <tr><td style="padding:6px 0;font-weight:900;font-size:17px">Total que paga el cliente</td><td style="padding:6px 0;text-align:right;font-weight:900;font-size:17px">${totalCliente}</td></tr>
                            </tbody>
                          </table>
                          <div class="alert alert-success" style="margin-top:12px;padding:12px;border-radius:10px;font-size:15px;">
                            <div style="font-weight:900;font-size:16px">Tú recibes: ${totalServicio}</div>
                            ${desgloseCobro?.esUrgente ? `<div style="margin-top:4px;font-size:13px">Base: ${precioBaseProveedor} + urgencia: ${montoUrgencia}</div>` : ''}
                          </div>
                        </div>`,
                      confirmButtonText: "Entendido",
                      customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" }
                    });
                  }}
                  title="Desglose"
                >
                  Desglose
                </button>
              </label>
              <input
                className="form-control"
                value={paquetes[paqueteActivo].precio}
                onChange={(e) => actualizarPaquete(paqueteActivo, 'precio', e.target.value)}
                onBlur={(e) => {
                  if (divisaServicio !== 'COP') return;

                  const precioNum = Number(String(e.target.value || "").replace(/[^0-9]/g, ""));
                  if (precioNum > 0 && precioNum < PRECIO_MINIMO_PAQUETE_COP) {
                    Swal.fire({
                      icon: 'warning',
                      title: 'Precio muy bajo',
                      text: `El precio mínimo a publicar en Zervicy son ${formatearMoneda(PRECIO_MINIMO_PAQUETE_COP, 'COP')}.`,
                      confirmButtonText: 'Entendido',
                      customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
                    });
                    actualizarPaquete(paqueteActivo, 'precio', '');
                  }
                }}
                placeholder="Ej: 50.000"
              />
              {divisaServicio === 'COP' && (
                <small className="text-muted">Precio mínimo por paquete: {formatearMoneda(PRECIO_MINIMO_PAQUETE_COP, 'COP')}.</small>
              )}
            </div>

            {/* DÍAS DE ENTREGA — por paquete (solo si es por Días) */}
            {(agendaBase.unidadEntrega || 'Dias') === 'Dias' && (
              <div className="col-12 col-md-6">
                <label className="form-label fw-bold">¿Cuántos días tarda este paquete?</label>
                <select
                  className="form-select"
                  value={String(paquetes[paqueteActivo].diasEntrega || '')}
                  onChange={(e) => actualizarPaquete(paqueteActivo, 'diasEntrega', e.target.value)}
                >
                  <option value="">Selecciona</option>
                  {Array.from({ length: 30 }).map((_, i) => {
                    const n = i + 1;
                    return <option key={`dias-${n}`} value={n}>{n} día{n === 1 ? '' : 's'}</option>;
                  })}
                </select>
                <small className="text-muted">Puede variar por paquete. Ej: Básico 2 días, Premium 5 días.</small>
              </div>
            )}

            {/* DURACIÓN DE CADA CITA (solo si es por Horas) */}
            {(agendaBase.unidadEntrega || 'Dias') === 'Horas' && (
              <div className="col-12 col-md-6">
                <label className="form-label fw-bold">¿Cuánto dura cada servicio de este paquete?</label>
                <select
                  className="form-select"
                  value={paquetes[paqueteActivo].duracionCitaMin || ""}
                  onChange={(e) => actualizarPaquete(paqueteActivo, 'duracionCitaMin', e.target.value)}
                >
                  <option value="">Selecciona la duración</option>
                  {[
                    { min: 15,  label: "15 minutos"     },
                    { min: 20,  label: "20 minutos"     },
                    { min: 30,  label: "30 minutos"     },
                    { min: 45,  label: "45 minutos"     },
                    { min: 60,  label: "1 hora"         },
                    { min: 75,  label: "1 h 15 min"     },
                    { min: 90,  label: "1 hora 30 min"  },
                    { min: 105, label: "1 h 45 min"     },
                    { min: 120, label: "2 horas"        },
                    { min: 150, label: "2 horas 30 min" },
                    { min: 180, label: "3 horas"        },
                    { min: 210, label: "3 horas 30 min" },
                    { min: 240, label: "4 horas"        },
                    { min: 270, label: "4 horas 30 min" },
                    { min: 300, label: "5 horas"        },
                    { min: 360, label: "6 horas"        },
                    { min: 420, label: "7 horas"        },
                    { min: 480, label: "8 horas"        },
                    { min: 540, label: "9 horas"        },
                    { min: 600, label: "10 horas"       },
                  ].map(({ min, label }) => (
                    <option key={min} value={min}>{label}</option>
                  ))}
                </select>
                <small className="text-muted">Puede variar por paquete. Ej: Básico 1 hora, Premium 2 horas.</small>
              </div>
            )}

            {/* SERVICIOS POR DÍA — por paquete (solo si es por Horas) */}
            {(agendaBase.unidadEntrega || 'Dias') === 'Horas' && (
              <div className="col-12 col-md-6">
                <label className="form-label fw-bold">¿Cuántos de este paquete puedes hacer en un día?</label>
                <select
                  className="form-select"
                  value={paquetes[paqueteActivo].citasDia || ""}
                  onChange={(e) => {
                    const v = String(e.target.value || "");
                    const n = Number(v);
                    const lim = Number.isFinite(n) ? Math.max(1, Math.min(12, n)) : 0;
                    const prevHor = Array.isArray(paquetes[paqueteActivo].horariosDia) ? paquetes[paqueteActivo].horariosDia : [];
                    const nextHor = lim > 0 ? Array.from({ length: lim }).map((_, i) => prevHor[i] || "") : [];
                    actualizarPaquete(paqueteActivo, 'citasDia', lim ? String(lim) : "");
                    actualizarPaquete(paqueteActivo, 'horariosDia', nextHor);
                  }}
                >
                  <option value="">Selecciona</option>
                  {Array.from({ length: 12 }).map((_, i) => {
                    const n = i + 1;
                    return <option key={n} value={n}>{n}</option>;
                  })}
                </select>
                <small className="text-muted">Puede variar según la duración de este paquete.</small>
              </div>
            )}

            {/* HORARIOS EXACTOS — por paquete (solo si es Horas + modo exacta) */}
            {(agendaBase.unidadEntrega || 'Dias') === 'Horas' && (agendaBase.modoAgenda || 'exacta') === 'exacta' && (
              <div className="col-12">
                <label className="form-label fw-bold">Horarios disponibles para este paquete</label>
                <div className="row g-2">
                  {(Array.isArray(paquetes[paqueteActivo].horariosDia) ? paquetes[paqueteActivo].horariosDia : []).map((h, idx) => (
                    <div className="col-12 col-sm-6 col-lg-4" key={`hor-${paqueteActivo}-${idx}`}>
                      <div className="input-group">
                        <span className="input-group-text">#{idx + 1}</span>
                        <input
                          type="time"
                          className="form-control"
                          value={h || ""}
                          onChange={(e) => {
                            const arr = [...(Array.isArray(paquetes[paqueteActivo].horariosDia) ? paquetes[paqueteActivo].horariosDia : [])];
                            arr[idx] = e.target.value;
                            actualizarPaquete(paqueteActivo, 'horariosDia', arr);
                          }}
                        />
                      </div>
                    </div>
                  ))}
                  {!(Number(paquetes[paqueteActivo].citasDia) > 0) && (
                    <div className="col-12">
                      <small className="text-muted">Primero selecciona cuántos servicios haces en un día.</small>
                    </div>
                  )}
                </div>
                <small className="text-muted">Selecciona las horas en las que inician los servicios de este paquete.</small>
              </div>
            )}

            {/* DESCRIPCIÓN CORTA */}
            <div className="col-12">
              <label className="form-label fw-bold">Descripción corta</label>
              <input
                className="form-control"
                value={paquetes[paqueteActivo].descripcion}
                maxLength={200}
                onChange={(e) => actualizarPaquete(paqueteActivo, 'descripcion', e.target.value)}
                placeholder="Ej: Incluye X, Y, Z"
              />
              <small className="text-muted">Máximo 200 caracteres.</small>
            </div>

            {/* INCLUYE */}
            <div className="col-12">
              <label className="form-label fw-bold">Incluye (una línea por ítem)</label>
              <textarea
                className="form-control"
                rows={4}
                value={paquetes[paqueteActivo].detalles}
                maxLength={800}
                onChange={(e) => actualizarPaquete(paqueteActivo, 'detalles', e.target.value)}
                placeholder={`Ej:\n- Entrega en PDF\n- 2 revisiones\n- Soporte por chat`}
              />
              <small className="text-muted">Máximo 800 caracteres.</small>
            </div>

          </div>
        </div>

        {/* Navegación Paso 4 */}
        <BotonesaPasos
          anterior={() => setPasoActual(3)}
          siguiente={() => setPasoActual(5)}
          onGuardar={(incluirPaquetes) => guardarProgreso({ mostrarAlerta: true, incluirPaquetes })}
          incluirPaquetesEnGuardar={true}
        />
      </div>
    </div>
  );
}

export default Paso4;
